<template>
    <div class="sl-academy-news">
        <div class="p-8">
            <!-- Headline -->
            <div class="mb-4 text-2xl">
                <img
                    src="/img/logo-swisslens-white.svg"
                    alt="SwissLens"
                    class="inline align-baseline h-5"
                >

                <span class="ml-2 align-baseline">
                    {{ t('news.sl_academy.headline') }}
                </span>
            </div>

            <!-- Paragraphs -->
            <div class="mb-8 text-base space-y-1">
                <p>{{ t('news.sl_academy.paragraph1') }}</p>
                <p>{{ t('news.sl_academy.paragraph2') }}</p>
            </div>

            <!-- Call To Action -->
            <a
                href="https://www.swisslens.ch/allevent/"
                target="_blank"
                class="sl-academy-news__cta"
            >
                {{ t('news.sl_academy.cta') }}
            </a>
        </div>

        <!-- Side Illustration -->
        <div class="flex justify-center items-center pr-8">
            <mdi-icon
                icon="mdiCalendarMonthOutline"
                class="w-24 text-[var(--accent)]"
            />
        </div>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n({ useScope: 'global' });
</script>

<style scoped>
@reference "#main.css";

.sl-academy-news
{
    --accent: #e0dd04;

    @apply flex justify-between items-stretch rounded-lg bg-primary-900
        bg-gradient-to-tl from-primary-900 to-primary-500
        text-white text-left overflow-hidden;
}

.sl-academy-news__cta
{
    @apply inline-block rounded px-6 py-3 shadow-lg
        bg-[var(--accent)] text-primary-900 transition;

    &:hover
    {
        background-color: hwb(from var(--accent) h w b / 0.8);
    }
}
</style>
